<template>
  <div>
    <v-row>
      <v-col cols="12" class="">
        <form>
          <div class="flex justify-start gap-12 mb-7">
            <div class="w-[440px]">
              <div class="single_radio flex">
                <label
                  for="subjectToVat"
                  class="inline-flex relative items-center cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id="subjectToVat"
                    class="sr-only peer"
                    v-model="basicInfo.is_vat"
                    :disabled="
                      currentPath === '/edit-partner' &&
                      isEditPartner &&
                      !isEditButton
                    "
                  />
                  <div
                    class="w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] peer-checked:after:bg-white after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#AE6A65]"
                  ></div>
                </label>
                <h3 class="ml-5">{{ $t("partners.subjectToVat") }}</h3>
              </div>
            </div>
          </div>
          <div class="flex justify-start gap-12 mb-7">
            <div class="w-[440px]">
              <app-input-field
                id="1"
                :label="$t('partners.taxNumber')"
                :placeholder="$t('partners.enterTaxNumber')"
                v-model:modelValue="basicInfo.tax_number"
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
              ></app-input-field>
            </div>
            <div class="w-[440px]">
              <app-input-field
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="2"
                :label="$t('partners.vatExempt')"
                :placeholder="$t('partners.vatExempt')"
              ></app-input-field>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <div class="w-[920px]">
                <div
                  v-if="currentPath !== '/edit-partner'"
                  class="flex justify-end mb-7"
                >
                  <div class="flex gap-3">
                    <div>
                      <app-secondary-button
                        :buttonLabel="$t('personal.saveAndExit')"
                        @click-event="savePartnerInfo('exit')"
                      >
                      </app-secondary-button>
                    </div>
                    <div>
                      <app-primary-button
                        @click-event="savePartnerInfo('continue')"
                        :buttonLabel="$t('employment.saveChanges')"
                      >
                      </app-primary-button>
                    </div>
                  </div>
                </div>
                <div v-else class="flex justify-end gap-7">
                  <div v-show="isEditButton">
                    <app-secondary-button
                      :buttonLabel="$t('personal.cancel')"
                      @click="cancel"
                    ></app-secondary-button>
                  </div>
                  <app-primary-button
                    v-show="isEditButton"
                    :buttonLabel="$t('employment.saveChanges')"
                    @click-event="savePartnerInfo('edit')"
                  >
                  </app-primary-button>
                </div>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-col>
    </v-row>

    <app-alert
      :title="$t(getTranslatedStringKey(alertTitle))"
      @close-alert="alertState = false"
      :state="alertState"
      :timeout="5000"
      :type="alertType"
    />
  </div>
  <div class="modal-board" v-if="showmodal && basicInfo.official_email === ''">
    <div class="flex justify-between">
      <h3 class="H400">We recommend that you provide an email</h3>
      <v-icon icon="custom:closeIcon" @click="showmodal = false" />
    </div>
    <p class="P300">
      Leaving the email blank means employees won’t receive any invitation
      email.
    </p>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import countries from "@/services/country_api";
import { getTransString } from "@/services/helpers";
import Api from "@/services/api";
import { isEqual } from "lodash";
export default defineComponent({
  name: "Additional Information",
  components: {},
  props: {
    errors: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      alertType: "success",
      alertState: false,
      alertTitle: "",
      firstRunRef: true,
      isEdit: false,
      loadUserKey: null,
      countryOptions: null,
      countryCitizensArray: [],
      originalFormData: {},
      basicInfo: {
        tax_number: "",
        is_vat: false,
      },
      allUserRoles: [],
      page: 1,
      roles: [],
      showmodal: true,
    };
  },
  computed: {
    isEditPartner() {
      return this.$store.getters["partnerModules/isEditPartner"];
    },
    canEditPersonalModule() {
      return this.$store.state.auth.canEditModuleSections;
    },
    isEditButton() {
      return (
        this.$store.getters["partnerModules/isEditButton"] &&
        this.canEditPersonalModule?.includes("Additional Information")
      );
    },
    isPartnerData() {
      return this.$store.getters["partnerModules/isPartnerInfo"];
    },
    isPartnerId() {
      return this.$store.getters["partnerModules/isPartnerId"];
    },
    currentPath() {
      return this.$route.path;
    },
  },
  watch: {
    isPartnerData(value) {
      Object.keys(value).forEach((elt) => {
        if (Object.keys(this.basicInfo).includes(elt)) {
          this.basicInfo[elt] = value[elt];
          if (this.firstRunRef) {
            this.originalFormData[elt] = value[elt];
          }
        }
      });
      if (this.firstRunRef) {
        this.firstRunRef = false;
      }
    },
    basicInfo: {
      deep: true,
      handler(value) {
        this.$store.commit("partnerModules/SET_PARTNER_UPDATE", {
          AdditionalInformation: !isEqual(value, this.originalFormData),
        });
      },
    },
  },
  methods: {
    getCountryByName() {
      const countryArray = [];
      for (const country of countries) {
        countryArray.push(country.name);
      }
      return countryArray;
    },
    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    handleNextClick() {
      this.$emit("next-clicked");
    },
    cancel() {
      this.$router.go(-1);
    },
    savePartnerInfo(data) {
      const payload = { ...this.basicInfo };

      if (this.isPartnerId) {
        payload.partner_id = this.isPartnerId;
      }

      Api()
        .post("/partners/add-new-partner/", payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.$store.commit(
              "partnerModules/SET_PARTNER_KEY_TO_STATE",
              response.data.data.partner_id
            );
            this.$store.commit(
              "partnerModules/SET_PERSONAl_DATA_TO_STATE",
              response.data.data
            );
            this.alertType = "success";
            this.alertTitle = response.data.detail;
            this.alertState = !this.alertState;

            this.$store.commit("partnerModules/SET_PARTNER_UPDATE", {
              AdditionalInformation: false,
            });

            setTimeout(() => {
              if (data === "exit") {
                this.$router.push({ name: "partners" });
              }
              if (data === "continue") {
                this.$store.commit(
                  "partnerModules/SET_CURRENT_TAB_TO_STATE",
                  4
                );
              }
            }, 1500);
          }
        })
        .catch((error) => {
          if (error) {
            this.alertType = "error";
            this.alertTitle = error.response.data.detail;
            this.alertState = !this.alertState;
          }
        });
    },
    getPartnerInfo() {
      Api()
        .get(`/partners/get-partner-info/${this.isPartnerId}/`)
        .then((response) => {
          if (response.data.status === "success") {
            const data = response.data.data;
            this.$store.commit(
              "partnerModules/SET_PERSONAl_DATA_TO_STATE",
              data
            );
          }
        });
    },
  },
  created() {
    this.$store.commit(
      "partnerModules/SET_EDIT_PARTNER_TO_STATE",
      this.isPartnerId !== null
    );
    this.isEdit = this.isEditPartner;
    this.getPartnerInfo();
    this.$store.commit("partnerModules/SET_CURRENT_TAB_TO_STATE", 4);
  },
});
</script>

<style scoped>
.select-field {
  width: 440px;
}

.modal-board {
  position: fixed;
  top: 90%;
  left: 85%;
  transform: translate(-50%, -50%);
  right: 0;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  width: 396px;
  height: 98px;
  background: #ffffff;
  border: 1px solid #f2f4f7;
  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, 0.08),
    0 4px 6px -2px rgba(16, 24, 40, 0.03);
  border-radius: 8px;
}
.disabled {
  /* cursor: not-allowed; */
  color: gray;
  opacity: 0.5;
}
</style>
